import { render, staticRenderFns } from "./AboutTA10.vue?vue&type=template&id=05aa3262&scoped=true&"
import script from "./AboutTA10.vue?vue&type=script&lang=js&"
export * from "./AboutTA10.vue?vue&type=script&lang=js&"
import style0 from "./AboutTA10.vue?vue&type=style&index=0&id=05aa3262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa3262",
  null
  
)

export default component.exports